import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-submitscreen',
  imports: [ CommonModule],
  templateUrl: './submitscreen.component.html',
  styleUrls: ['./submitscreen.component.css']
})
export class SubmitscreenComponent implements OnInit {
  successMessage: string = '';
data:any;
  constructor(private router: Router) {}

  ngOnInit(): void {
    this.data = history.state?.data;
    if (this.data) {
        this.successMessage = 'DOA changes successful!';
    }
    else{
      this.successMessage = 'DOA changes unsuccessful!';
    }
}

  onClick(): void {
    this.router.navigate(['PermanentDelegation/home']);
  }

  click(): void {
    window.history.go(-2);
    }
}